const zh = {
    all: '全部',
    mainBranch: '主分支',
    branchVersion: '分支版本',
    recordList: '记录列表',
    add: '添加',
    versionNum: '版本号',
    updateDesc: '更新说明',
    file: '文件(.apk)',
    downTips: '正在下载，请稍后。',
    downFailError: '下载失败，{{error}}',
    addAppRecord: '添加APP发布记录',
    plFillInfo: '请将信息填写完整!',
    addSuccess:'添加成功',
    delApk: '删除apk',
};

export default zh;